// import React, { useEffect, useState } from 'react';

// const UserTablesList = () => {
//   const [tables, setTables] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   const user = JSON.parse(sessionStorage.getItem('user'));
//   //   if (!user || !user.id) {
//   //     alert('User not logged in');
//   //     setLoading(false);
//   //     return;
//   //   }
//   //   fetch(`https://botapi.emedha.in/pages/api/api/tables?userId=${user.id}`)
//   //     .then(res => res.json())
//   //     .then(data => {
//   //       setTables(data);
//   //       setLoading(false);
//   //     })
//   //     .catch(err => {
//   //       console.error('Error fetching tables:', err);
//   //       setLoading(false);
//   //     });
//   // }, []);
//     useEffect(() => {
//     const storedUser = JSON.parse(sessionStorage.getItem('user'));

//     if (!storedUser) {
//       alert('User not logged in');
//       setLoading(false);
//       return;
//     }

//     // 🔥 ROLE CHECK
//     // const isAdmin = storedUser.role === "admin";
//     // const isMember = storedUser.role === "member";

//     // 🔥 Correct userId based on role
//     // const finalUserId = isAdmin ? storedUser.id : storedUser.userId;
// const adminId = storedUser.role === "admin" ? storedUser.id : storedUser.userId;

//     if (!adminId) {
//       alert("User ID missing!");
//       setLoading(false);
//       return;
//     }
//     console.log('this is adminId',adminId)

//     // 🔥 API CALL
//     fetch(`https://botapi.emedha.in/pages/api/api/tables?userId=${adminId}`)
//       .then(res => res.json())
//       .then(data => {

//            const groupsData = data;

//       // Filter the groups based on the user role
//         // Filter the groups based on the user role
//       let filteredGroups;
//       if (storedUser.role === "admin") {
//         // Admin sees all groups, including empty role groups
//         filteredGroups = groupsData;
//       } else if (storedUser.role === "member") {
//         // Member only sees their own groups (where member_id matches)
//         filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === storedUser.id);
//       }
//         setTables(filteredGroups);
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error('Error fetching tables:', err);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center mt-5">
//         <div className="spinner-border text-primary" role="status" />
//         <span className="ms-2">Loading tables...</span>
//       </div>
//     );
//   }

//   if (!tables.length) {
//     return <div className="alert alert-info mt-4">No tables found for this user.</div>;
//   }

//   return (
//     <div className="container mt-4" style={{ fontFamily: 'Segoe UI, sans-serif', fontSize: '12px' }}>
//       <h4 className="mb-3">📊 YOUR CREATED TABLES</h4>
//       <div className="table-responsive">
//         <table className="table table-striped table-hover table-bordered">
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Table Name</th>
//               <th>User Name</th>
//               <th>Created Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {tables.map((table, index) => (
//               <tr key={table.sno}>
//                 <td>{index + 1}</td>
//                 <td><strong>{table.table_name}</strong></td>
//                 <td><strong>{table.user_name}</strong></td>
//                 <td>{new Date(table.created_date).toLocaleString()}</td>
//                 <td>
//                   <span className={`badge ${table.flag ? 'bg-success' : 'bg-secondary'}`}>
//                     {table.flag ? 'Active' : 'Inactive'}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default UserTablesList;




// import { useState, useEffect } from "react";
// import { List, Plus, ChevronLeft, ChevronRight } from "lucide-react";

// // Mocking your exact tables list data input
// const tablesData = [
//   { sNo: 1, tableName: "tbl_vj_26154406", userName: "emedhatechnologies@gmail.com", createdDate: "6/25/2026, 3:46:51 PM", status: "Active" },
//   { sNo: 2, tableName: "tbl_sudhaupdate_26143318", userName: "emedhatechnologies@gmail.com", createdDate: "5/28/2026, 2:33:43 PM", status: "Active" },
//   { sNo: 3, tableName: "tbl_sud108_26093026", userName: "emedhatechnologies@gmail.com", createdDate: "5/23/2026, 9:30:52 AM", status: "Active" },
//   { sNo: 4, tableName: "tbl_lbnstall_26130832", userName: "emedhatechnologies@gmail.com", createdDate: "4/16/2026, 1:09:39 PM", status: "Active" },
//   { sNo: 5, tableName: "tbl_fvdg2526_26175441", userName: "emedhatechnologies@gmail.com", createdDate: "3/24/2026, 5:54:55 PM", status: "Active" },
//   { sNo: 6, tableName: "tbl_test1234_26224621", userName: "emedhatechnologies@gmail.com", createdDate: "1/25/2026, 10:46:38 PM", status: "Active" },
//   { sNo: 7, tableName: "tbl_member_25124914", userName: "emedhatechnologies@gmail.com", createdDate: "12/5/2025, 12:49:25 PM", status: "Active" },
//   { sNo: 8, tableName: "tbl_admin_25124853", userName: "emedhatechnologies@gmail.com", createdDate: "12/5/2025, 12:49:08 PM", status: "Active" },
//   { sNo: 9, tableName: "tbl_isameinfoflyer_25115705", userName: "emedhatechnologies@gmail.com", createdDate: "12/5/2025, 11:57:31 AM", status: "Active" },
//   { sNo: 10, tableName: "tbl_dailyreminders_25094147", userName: "emedhatechnologies@gmail.com", createdDate: "12/4/2025, 9:42:06 AM", status: "Active" },
//   { sNo: 11, tableName: "tbl_isameapp_25162209", userName: "emedhatechnologies@gmail.com", createdDate: "12/3/2025, 4:22:22 PM", status: "Active" },
//   { sNo: 12, tableName: "tbl_isameprofileupdate_25125249", userName: "emedhatechnologies@gmail.com", createdDate: "11/29/2025, 12:53:22 PM", status: "Active" },
//   { sNo: 13, tableName: "tbl_isamereg1_25115320", userName: "emedhatechnologies@gmail.com", createdDate: "11/29/2025, 11:53:41 AM", status: "Active" },
//   { sNo: 14, tableName: "tbl_lbnmembers_25150632", userName: "emedhatechnologies@gmail.com", createdDate: "11/25/2025, 3:06:46 PM", status: "Active" },
//   { sNo: 15, tableName: "tbl_registeredmultiplewise_25133655", userName: "emedhatechnologies@gmail.com", createdDate: "11/1/2025, 1:37:30 PM", status: "Active" },
//   { sNo: 16, tableName: "tbl_pdgsindia_25175714", userName: "emedhatechnologies@gmail.com", createdDate: "10/29/2025, 5:57:33 PM", status: "Active" },
//   { sNo: 17, tableName: "tbl_isamepromo_25150330", userName: "emedhatechnologies@gmail.com", createdDate: "10/8/2025, 3:03:57 PM", status: "Active" },
//   { sNo: 18, tableName: "tbl_isamepromo_25154442", userName: "emedhatechnologies@gmail.com", createdDate: "10/7/2025, 3:46:43 PM", status: "Active" },
//   { sNo: 19, tableName: "tbl_dgdir_25095913", userName: "emedhatechnologies@gmail.com", createdDate: "10/4/2025, 9:59:26 AM", status: "Active" },
//   { sNo: 20, tableName: "tbl_isamereg_25202933", userName: "emedhatechnologies@gmail.com", createdDate: "10/3/2025, 8:30:13 PM", status: "Active" },
//   { sNo: 21, tableName: "tbl_dgteam_25105748", userName: "emedhatechnologies@gmail.com", createdDate: "10/3/2025, 10:57:48 AM", status: "Active" }
// ];

// export default function UserTablesList() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isMobile, setIsMobile] = useState(false);
//   const itemsPerPage = 5;

//   // Handle responsiveness for innerWidth (mimics md break point at 768px)
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     handleResize(); // run on mount
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Calculate dynamic pagination states
//   const totalItems = tablesData.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
//   const currentItems = tablesData.slice(startIndex, endIndex);

//   // Status Badge Component
//   const renderStatusBadge = (status) => (
//     <span
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//         padding: "2px 8px",
//         borderRadius: "9999px",
//         fontSize: "11px",
//         fontWeight: 500,
//         backgroundColor: "#ecfdf5",
//         color: "#047857",
//         border: "1px solid #a7f3d0",
//       }}
//     >
//       {status}
//     </span>
//   );

//   return (
//     // Replaced PageWrapper with inline-styled container layout
//     <div
//       style={{
//         padding: "24px",
//         backgroundColor: "#f8fafc",
//         borderRadius: "16px",
//         border: "1px solid #e2e8f0",
//         fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//       }}
//     >
//       {/* Header Section */}
//       <div
//         style={{
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           justifyContent: "between",
//           alignItems: isMobile ? "stretch" : "center",
//           justifyContent: "space-between",
//           gap: "16px",
//           borderBottom: "1px solid #e2e8f0",
//           paddingBottom: "16px",
//           marginBottom: "16px",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "#f1f5f9",
//               padding: "8px",
//               borderRadius: "8px",
//               color: "#475569",
//             }}
//           >
//             <List size={17} />
//           </div>
//           <div>
//             <h1 style={{ fontSize: "20px", fontWeight: 700, color: "#0f172a", margin: 0 }}>User Tables List</h1>
//             <p style={{ fontSize: "14px", color: "#64748b", margin: "4px 0 0 0" }}>All configured data tables</p>
//           </div>
//         </div>
//         <button
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             backgroundColor: "#4f46e5",
//             color: "#ffffff",
//             padding: "8px 16px",
//             borderRadius: "8px",
//             border: "none",
//             fontWeight: 500,
//             fontSize: "14px",
//             cursor: "pointer",
//             width: isMobile ? "100%" : "auto",
//           }}
//         >
//           <Plus size={14} /> New Table
//         </button>
//       </div>

//       <div>
//         <h3
//           style={{
//             fontSize: "14px",
//             fontWeight: 600,
//             color: "#64748b",
//             marginBottom: "16px",
//             letterSpacing: "0.05em",
//             textTransform: "uppercase",
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//           }}
//         >
//           📊 Your Created Tables
//         </h3>

//         {/* 1. MOBILE LAYOUT: Stacked card container */}
//         {isMobile ? (
//           <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//             {currentItems.map((item) => (
//               <div
//                 key={item.sNo}
//                 style={{
//                   padding: "16px",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: "12px",
//                   backgroundColor: "#ffffff",
//                   boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     borderBottom: "1px solid #f1f5f9",
//                     paddingBottom: "8px",
//                     marginBottom: "4px",
//                   }}
//                 >
//                   <span style={{ fontSize: "12px", fontWeight: 700, color: "#94a3b8" }}># {item.sNo}</span>
//                   {renderStatusBadge(item.status)}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: 600,
//                     color: "#4f46e5",
//                     fontFamily: "monospace",
//                     wordBreak: "break-all",
//                   }}
//                 >
//                   {item.tableName}
//                 </div>
//                 <div style={{ fontSize: "12px", color: "#475569", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//                   <span style={{ fontWeight: 500, color: "#94a3b8" }}>User:</span> {item.userName}
//                 </div>
//                 <div style={{ fontSize: "12px", color: "#475569" }}>
//                   <span style={{ fontWeight: 500, color: "#94a3b8" }}>Created:</span> {item.createdDate}
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           /* 2. DESKTOP LAYOUT: Standard HTML Table with structural Inline CSS */
//           <div style={{ width: "100%", overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "12px", backgroundColor: "#ffffff" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "14px" }}>
//               <thead>
//                 <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
//                   {["#", "Table Name", "User Name", "Created Date", "Status"].map((col) => (
//                     <th key={col} style={{ padding: "12px 16px", fontWeight: 600, color: "#475569" }}>
//                       {col}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((item) => (
//                   <tr key={item.sNo} style={{ borderBottom: "1px solid #f1f5f9" }}>
//                     <td style={{ padding: "16px", color: "#64748b" }}>{item.sNo}</td>
//                     <td style={{ padding: "16px", fontFamily: "monospace", color: "#0f172a", fontWeight: 500 }}>
//                       {item.tableName}
//                     </td>
//                     <td style={{ padding: "16px", color: "#334155" }}>{item.userName}</td>
//                     <td style={{ padding: "16px", color: "#64748b", whiteSpace: "nowrap" }}>{item.createdDate}</td>
//                     <td style={{ padding: "16px" }}>{renderStatusBadge(item.status)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* 3. RESPONSIVE PAGINATION INTERFACE */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: window.innerWidth < 640 ? "column" : "row",
//             justifyContent: "between",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "16px",
//             marginTop: "20px",
//             padding: "16px",
//             border: "1px solid #e2e8f0",
//             borderRadius: "12px",
//             backgroundColor: "rgba(248, 250, 252, 0.7)",
//           }}
//         >
//           <div style={{ fontSize: "12px", color: "#64748b", textAlign: window.innerWidth < 640 ? "center" : "left" }}>
//             Showing <span style={{ fontWeight: 600, color: "#1e293b" }}>{totalItems === 0 ? 0 : startIndex + 1}</span> to{" "}
//             <span style={{ fontWeight: 600, color: "#1e293b" }}>{endIndex}</span> of{" "}
//             <span style={{ fontWeight: 600, color: "#1e293b" }}>{totalItems}</span> entries
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//             {/* Previous Page Button */}
//             <button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               style={{
//                 padding: "6px",
//                 border: "1px solid #e2e8f0",
//                 borderRadius: "8px",
//                 backgroundColor: "#ffffff",
//                 color: "#475569",
//                 cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                 opacity: currentPage === 1 ? 0.4 : 1,
//                 display: "flex",
//                 alignItems: "center",
//                 transition: "all 0.2s",
//               }}
//             >
//               <ChevronLeft size={16} />
//             </button>

//             {/* Page Number Buttons */}
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
//               const isActive = currentPage === page;
//               return (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   style={{
//                     padding: "4px 12px",
//                     fontSize: "12px",
//                     fontWeight: 500,
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                     transition: "all 0.2s",
//                     border: isActive ? "none" : "1px solid #e2e8f0",
//                     backgroundColor: isActive ? "#4f46e5" : "#ffffff",
//                     color: isActive ? "#ffffff" : "#475569",
//                     boxShadow: isActive ? "0 1px 2px 0 rgba(0, 0, 0, 0.05)" : "none",
//                   }}
//                 >
//                   {page}
//                 </button>
//               );
//             })}

//             {/* Next Page Button */}
//             <button
//               onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//               disabled={currentPage === totalPages}
//               style={{
//                 padding: "6px",
//                 border: "1px solid #e2e8f0",
//                 borderRadius: "8px",
//                 backgroundColor: "#ffffff",
//                 color: "#475569",
//                 cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                 opacity: currentPage === totalPages ? 0.4 : 1,
//                 display: "flex",
//                 alignItems: "center",
//                 transition: "all 0.2s",
//               }}
//             >
//               <ChevronRight size={16} />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import { List, Plus, ChevronLeft, ChevronRight, Search } from "lucide-react";

const UserTablesList = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  
  // Design Layout States
  const [currentPage, setCurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const itemsPerPage = 10;

  // Handle responsiveness for innerWidth (mimics md breakpoint at 768px)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem('user'));

    if (!storedUser) {
      alert('User not logged in');
      setLoading(false);
      return;
    }

    // Correct userId based on role
    const adminId = storedUser.role === "admin" ? storedUser.id : storedUser.userId;

    if (!adminId) {
      alert("User ID missing!");
      setLoading(false);
      return;
    }

    // API CALL
    fetch(`https://botapi.emedha.in/pages/api/api/tables?userId=${adminId}`)
      .then(res => res.json())
      .then(data => {
        const groupsData = data;

        // Filter the groups based on the user role
        let filteredGroups = [];
        if (storedUser.role === "admin") {
          filteredGroups = groupsData;
        } else if (storedUser.role === "member") {
          filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === storedUser.id);
        }
        setTables(filteredGroups);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching tables:', err);
        setLoading(false);
      });
  }, []);

  // Reset pagination to page 1 whenever search query changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  // Filter tables based on search bar query
  const filteredTables = tables.filter(table => {
    const query = searchQuery.toLowerCase();
    return (
      (table.table_name && table.table_name.toLowerCase().includes(query)) ||
      (table.user_name && table.user_name.toLowerCase().includes(query))
    );
  });

  // Calculate dynamic pagination states based on filtered data
  const totalItems = filteredTables.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const currentItems = filteredTables.slice(startIndex, endIndex);

  // Reusable Premium Status Badge Component matching table.flag
  const renderStatusBadge = (flag) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 8px",
        borderRadius: "9999px",
        fontSize: "11px",
        fontWeight: 500,
        backgroundColor: flag ? "#ecfdf5" : "#f1f5f9",
        color: flag ? "#047857" : "#475569",
        border: flag ? "1px solid #a7f3d0" : "1px solid #cbd5e1",
      }}
    >
      {flag ? 'Active' : 'Inactive'}
    </span>
  );

  if (loading) {
    return (
      <div 
        style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          marginTop: "48px",
          gap: "12px",
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}
      >
        <div 
          style={{ 
            width: "24px", 
            height: "24px", 
            border: "3px solid #e2e8f0", 
            borderTop: "3px solid #4f46e5", 
            borderRadius: "50%", 
            animation: "spin 1s linear infinite" 
          }} 
        />
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        <span style={{ fontSize: "14px", color: "#475569", fontWeight: 500 }}>Loading tables...</span>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: isMobile ? "16px" : "24px",
        backgroundColor: "#f8fafc",
        borderRadius: "16px",
        border: "1px solid #e2e8f0",
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
          justifyContent: "space-between",
          gap: "16px",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "16px",
          marginBottom: "16px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f1f5f9",
              padding: "8px",
              borderRadius: "8px",
              color: "#475569",
            }}
          >
            <List size={17} />
          </div>
          <div>
            <h1 style={{ fontSize: "20px", fontWeight: 700, color: "#0f172a", margin: 0 }}>User Tables List</h1>
            <p style={{ fontSize: "14px", color: "#64748b", margin: "4px 0 0 0" }}>All configured data tables</p>
          </div>
        </div>

        {/* Search Bar Input Container */}
        <div 
          style={{ 
            position: "relative",
            width: isMobile ? "100%" : "300px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <Search 
            size={16} 
            style={{ 
              position: "absolute", 
              left: "12px", 
              color: "#94a3b8",
              pointerEvents: "none"
            }} 
          />
          <input 
            type="text" 
            placeholder="Search tables or users..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 12px 8px 36px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              outline: "none",
              backgroundColor: "#ffffff",
              color: "#1e293b",
              transition: "border-color 0.2s",
            }}
          />
        </div>
      </div>

      <div>
        <h3
          style={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#64748b",
            marginBottom: "16px",
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          📊 YOUR CREATED TABLES
        </h3>

        {/* Fallback View for No Search Results / Empty Database */}
        {totalItems === 0 ? (
          <div 
            style={{ 
              padding: "24px", 
              backgroundColor: "#f8fafc", 
              color: "#64748b", 
              border: "1px dashed #cbd5e1", 
              borderRadius: "12px",
              fontSize: "14px",
              textAlign: "center",
              fontWeight: 500
            }}
          >
            {tables.length === 0 ? "No tables found for this user." : "No matching configurations found."}
          </div>
        ) : isMobile ? (
          /* 1. MOBILE LAYOUT: Stacked card container */
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {currentItems.map((table, index) => (
              <div
                key={table.sno || index}
                style={{
                  padding: "16px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f1f5f9",
                    paddingBottom: "8px",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontSize: "12px", fontWeight: 700, color: "#94a3b8" }}># {startIndex + index + 1}</span>
                  {renderStatusBadge(table.flag)}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#4f46e5",
                    fontFamily: "monospace",
                    wordBreak: "break-all",
                  }}
                >
                  {table.table_name}
                </div>
                <div style={{ fontSize: "12px", color: "#475569", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  <span style={{ fontWeight: 500, color: "#94a3b8" }}>User:</span> {table.user_name}
                </div>
                <div style={{ fontSize: "12px", color: "#475569" }}>
                  <span style={{ fontWeight: 500, color: "#94a3b8" }}>Created:</span> {new Date(table.created_date).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* 2. DESKTOP LAYOUT: Standard HTML Table with Premium Shell Styling */
          <div style={{ width: "100%", overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "12px", backgroundColor: "#ffffff" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "14px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  {["#", "Table Name", "User Name", "Created Date", "Status"].map((col) => (
                    <th key={col} style={{ padding: "12px 16px", fontWeight: 600, color: "#475569" }}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((table, index) => (
                  <tr key={table.sno || index} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "16px", color: "#64748b" }}>{startIndex + index + 1}</td>
                    <td style={{ padding: "16px", fontFamily: "monospace", color: "#0f172a", fontWeight: 600 }}>
                      {table.table_name}
                    </td>
                    <td style={{ padding: "16px", color: "#334155", fontWeight: 600 }}>{table.user_name}</td>
                    <td style={{ padding: "16px", color: "#64748b", whiteSpace: "nowrap" }}>
                      {new Date(table.created_date).toLocaleString()}
                    </td>
                    <td style={{ padding: "16px" }}>{renderStatusBadge(table.flag)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* 3. RESPONSIVE PAGINATION INTERFACE */}
        {totalItems > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              marginTop: "20px",
              padding: "16px",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              backgroundColor: "rgba(248, 250, 252, 0.7)",
            }}
          >
            <div style={{ fontSize: "12px", color: "#64748b", textAlign: isMobile ? "center" : "left" }}>
              Showing <span style={{ fontWeight: 600, color: "#1e293b" }}>{startIndex + 1}</span> to{" "}
              <span style={{ fontWeight: 600, color: "#1e293b" }}>{endIndex}</span> of{" "}
              <span style={{ fontWeight: 600, color: "#1e293b" }}>{totalItems}</span> entries
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {/* Previous Page Button */}
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  color: "#475569",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.4 : 1,
                  display: "flex",
                  alignItems: "center",
                  transition: "all 0.2s",
                }}
              >
                <ChevronLeft size={16} />
              </button>

              {/* Page Number Buttons */}
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                const isActive = currentPage === page;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    style={{
                      padding: "4px 12px",
                      fontSize: "12px",
                      fontWeight: 500,
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      border: isActive ? "none" : "1px solid #e2e8f0",
                      backgroundColor: isActive ? "#4f46e5" : "#ffffff",
                      color: isActive ? "#ffffff" : "#475569",
                      boxShadow: isActive ? "0 1px 2px 0 rgba(0, 0, 0, 0.05)" : "none",
                    }}
                  >
                    {page}
                  </button>
                );
              })}

              {/* Next Page Button */}
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  color: "#475569",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.4 : 1,
                  display: "flex",
                  alignItems: "center",
                  transition: "all 0.2s",
                }}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTablesList;